import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CommonConstant } from 'src/app/constants/common-constant';
import { QuestionConstant } from 'src/app/constants/label-constants';
import { QuestionType } from 'src/app/enum/question-enum';
import { questionOptions } from 'src/app/models/questionModel';
import { EncrDecrService } from 'src/app/services/EncrDecr.service';
import { CommonService } from 'src/app/services/common/common.service';
@Component({
  selector: 'app-question-view',
  templateUrl: './question-view.component.html',
  styleUrls: ['./question-view.component.scss']
})
export class QuestionViewComponent {
  @ViewChild('fileQuestion') myfileQuestionElementRef!: ElementRef;
  questionOptionArray: Array<questionOptions> = [];
  files!: File;
  imageURL: any;
  enum: typeof QuestionType = QuestionType;
  showImage: boolean = false;
  showParagraphText: boolean = false;
  showRadio: boolean = true;
  showMultiSelect: boolean = false;
  SingleSelect: boolean = false;
  initalValues: any;
  saveStatus: boolean = false;
  formUnchanged = false;
  questionTypeList: any = [];
  questionSetList: any = [];
  questionEditForm: FormGroup = this.formBuilder.group({});
  QuestionForm: FormGroup = this.formBuilder.group({});
  QuestionId: number = 0;
  ParagraphId: number = 0;
  QuestionTypeId: number = 0;
  optionCheckItem: FormArray<any> | undefined;
  atLeastParagraphOneCheckboxChecked: boolean = false;
  multiQuestionCheckItem: FormArray<any> | undefined;
  multiOptionCheckItem: FormArray<any> | undefined;
  fileName = '';
  oldAndNewOptions: any = [];
  atLeastOneCheckboxChecked = false;
  CommonConstant: any = [];
  QuestionConstant: any = [];
  optionValue: any;

  constructor(
    private formBuilder: FormBuilder,
    public CommonService: CommonService,
    private toster: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private apiUrl: ApiUrlHelper,
    private EncrDecr: EncrDecrService,
    private spinner: NgxSpinnerService
  ) { }

  async ngOnInit() {
    this.CommonConstant = CommonConstant;
    this.QuestionConstant = QuestionConstant;
    this.questionEditForm = new FormGroup({
      questionId: new FormControl(0),
      questionText: new FormControl({ value: '', disabled: true }, [Validators.required, Validators.maxLength(500)]),
      questionTypeId: new FormControl({ value: '', disabled: true }, [Validators.required]),
      questionSetId: new FormControl({ value: '', disabled: true }, [Validators.required]),
      paragraphText: new FormControl({ value: '', disabled: true }),
      questionImage: new FormControl(),
      questionOptions: this.formBuilder.array([]),
      multiQuestions:
        new FormArray([])
    });
    this.route.params.subscribe((params) => {
      if (params['id'] !== undefined && params['type'] != 'paragraph') {
        var decrypted = params['id'] ? params['id'] : '';
        this.QuestionId = Number(this.EncrDecr.get('123456$#@$^@1ERF', decrypted));
      }
      else {
        var decrypted = params['id'] ? params['id'] : '';
        this.ParagraphId = Number(this.EncrDecr.get('123456$#@$^@1ERF', decrypted));
      }
    })
    if (this.QuestionId > 0) {
      this.questionEditForm.get('questionTypeId')?.disable();
      this.getQuestionById(this.QuestionId);
    }
    else if (this.ParagraphId > 0) {
      this.questionEditForm.get('questionTypeId')?.disable();
      this.questionEditForm.get('questionSetId')?.disable();
      this.getParagraphById(this.ParagraphId);
    }
    else {
      this.QuestionId = 0;
      this.ParagraphId = 0;
    }
    this.getQuestionTypeList();
    this.getQuestionSetList();
  }

  getMultiOptions(form) {
    return form.controls.multiOptions.controls;
  }

  getQuestionById(QuestionId: number) {
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.question.GetQuestionById.replace("{id}", QuestionId.toString());
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        this.questionEditForm.patchValue({
          questionText: data.data[0].questionText,
          questionTypeId: data.data[0].questionTypeId,
          questionSetId: data.data[0].questionSetId,
          paragraphText: data.data[0].paragraphText,
          questionImage: data.data[0].imageName,
        });
        this.onQuestionTypeChange();
        this.imageURL = data.data[0].imageName;
        this.QuestionTypeId = Number(this.questionEditForm.controls['questionTypeId'].value);
        if (this.QuestionTypeId == this.enum.MultiSelection ||
          this.QuestionTypeId == this.enum.ImageWithMultiSelection) {
          this.showMultiSelect = true;
          this.showRadio = false;
        }
        else if (this.QuestionTypeId == this.enum.SingleSelection ||
          this.QuestionTypeId == this.enum.ImageWithSingleSelection ||
          this.QuestionTypeId == this.enum.ParagraphWithSingleSelection) {
          this.showMultiSelect = false;
          this.showRadio = true;
        }
        if (this.QuestionTypeId == this.enum.ImageWithMultiSelection ||
          this.QuestionTypeId == this.enum.ImageWithSingleSelection) {
          this.showImage = true;
          this.showParagraphText = false;
        }
        else {
          this.showImage = false;
        }
        if (this.QuestionTypeId == this.enum.ParagraphWithSingleSelection) {
          this.showImage = false;
          this.showParagraphText = true;
        }
        else {
          this.showParagraphText = false;
        }
        const optionsArray = this.questionEditForm.get('questionOptions') as FormArray;
        data.data[0].questionOptiontList.forEach(option => {
          const optionFormGroup = this.formBuilder.group({
            isDeleted: false,
            questionOptionId: { value: option.questionOptionId, disabled: true },
            optionText: [{ value: option.optionText, disabled: true }, [Validators.required]],
            isCorrectAnswer: [{ value: option.isCorrectOption, disabled: true }, [Validators.required]]
          });
          optionsArray.push(optionFormGroup);
        });
        this.optionValue = data.data[0].questionOptiontList;
        this.initalValues = this.questionEditForm.getRawValue();
      },
      error: (err) => {
        this.spinner.hide();
      }
    });
  }

  getParagraphById(paragraphId: number) {
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.question.GetParagraphById.replace("{id}", paragraphId.toString());
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        this.showParagraphText = true;
        this.questionEditForm.patchValue({
          questionId: data.data.questionList[0].questionId,
          questionText: data.data.questionList[0].questionText,
          questionTypeId: data.data.questionTypeId,
          questionSetId: data.data.questionSetId,
          paragraphText: data.data.paragraphText,
          questionImage: "",
        });
        this.onQuestionTypeChange();
        const optionsArray = this.questionEditForm.get('questionOptions') as FormArray;
        data.data.questionList[0].questionOptiontList.forEach(option => {
          const optionFormGroup = this.formBuilder.group({
            isDeleted: { value: false, disabled: true },
            questionOptionId: { value: option.questionOptionId, disabled: true },
            optionText: [{ value: option.optionText, disabled: true }, [Validators.required]],
            isCorrectAnswer: [{ value: option.isCorrectOption, disabled: true }, [Validators.required]]
          });
          optionsArray.push(optionFormGroup);
        });
        let multiQuestion = this.getMultiQuestionArrayControl();
        for (let i = 1; i < data.data.questionList.length; i++) {
          this.addQuestion();
          let multiQuestionGroup = this.multiQuestionCheck(i - 1);
          multiQuestionGroup.patchValue({
            multiQuestionId: data.data.questionList[i].questionId,
            multiQuestionText: data.data.questionList[i].questionText
          });
          let control = multiQuestion.at(i - 1).get('multiOptions') as FormArray;
          data.data.questionList[i].questionOptiontList.forEach(option => {
            const multiOptionFormGroup = this.formBuilder.group({
              isDeleted: { value: false, disabled: true },
              questionOptionId: { value: option.questionOptionId, disabled: true },
              multiOptionText: [{ value: option.optionText, disabled: true }, [Validators.required]],
              isCorrectAnswer: [{ value: option.isCorrectOption, disabled: true }, [Validators.required]]
            });
            control.push(multiOptionFormGroup);
          });
        }
        this.initalValues = this.questionEditForm.getRawValue();
        this.spinner.hide();
      },
      error: (err) => {
        this.spinner.hide();
      }
    });
  }

  initMultiQuestion() {
    return new FormGroup({
      multiQuestionId: new FormControl({ value: null, disabled: true }),
      multiQuestionText: new FormControl({ value: null, disabled: true }, [Validators.required]),
      multiOptions: new FormArray([])
    });
  }

  initMultiOptions() {
    return new FormGroup({
      isDeleted: new FormControl({ value: false, disabled: true }),
      multiOptionText: new FormControl({ value: null, disabled: true }, [Validators.required]),
      isCorrectAnswer: new FormControl({ value: false, disabled: true }, [Validators.required]),
      questionOptionId: new FormControl({ value: 0, disabled: true }, [Validators.required])
    });
  }

  addQuestion() {
    const control = <FormArray>this.questionEditForm.get('multiQuestions');
    control.push(this.initMultiQuestion());
  }

  multiQuestionCheck(index) {
    this.multiQuestionCheckItem = this.questionEditForm.get('multiQuestions') as FormArray;
    const formGroup = this.multiQuestionCheckItem.controls[index] as FormGroup;
    return formGroup;
  }

  getMultiQuestionArrayControl(): FormArray {
    return this.questionEditForm.get('multiQuestions') as FormArray;
  }

  getMultiQuestions(form) {
    return form.controls.multiQuestions.controls;
  }

  // Get multiQuestions FormArray
  get multiQuestions(): FormArray {
    return this.questionEditForm.get('multiQuestions') as FormArray;
  }

  // Get multiOptions at perticular Index number
  multiOptions(i: number): FormArray {
    const multiOptions = this.multiQuestions.at(i) as FormGroup
    return multiOptions.get('multiOptions') as FormArray
  }

  onQuestionTypeChange() {
    this.QuestionTypeId = Number(this.questionEditForm.controls['questionTypeId'].value);
    switch (this.QuestionTypeId) {
      case this.enum.SingleSelection:
        this.showParagraphText = false;
        this.showImage = false;
        this.showRadio = true;
        this.showMultiSelect = false;
        this.questionEditForm.get('questionImage')?.clearValidators();
        this.questionEditForm.get('questionImage')?.setErrors(null);
        this.questionEditForm.get('paragraphText')?.clearValidators();
        this.questionEditForm.get('paragraphText')?.setErrors(null);
        break;
      case this.enum.MultiSelection:
        this.showParagraphText = false;
        this.showImage = false;
        this.showRadio = false;
        this.showMultiSelect = true;
        this.questionEditForm.get('questionImage')?.clearValidators();
        this.questionEditForm.get('questionImage')?.setErrors(null);
        this.questionEditForm.get('paragraphText')?.clearValidators();
        this.questionEditForm.get('paragraphText')?.setErrors(null);
        break;
      case this.enum.ImageWithSingleSelection:
        this.showParagraphText = false;
        this.showImage = true;
        this.showRadio = true;
        this.showMultiSelect = false;
        this.questionEditForm.get('questionImage')?.addValidators(Validators.required);
        this.questionEditForm.get('paragraphText')?.clearValidators();
        this.questionEditForm.get('paragraphText')?.setErrors(null);
        break;
      case this.enum.ImageWithMultiSelection:
        this.showParagraphText = false;
        this.showImage = true;
        this.showRadio = false;
        this.showMultiSelect = true;
        this.questionEditForm.get('questionImage')?.addValidators(Validators.required);
        this.questionEditForm.get('paragraphText')?.clearValidators();
        this.questionEditForm.get('paragraphText')?.setErrors(null);
        break;
      case this.enum.ParagraphWithSingleSelection:
        this.showParagraphText = true;
        this.showImage = false;
        this.showRadio = true;
        this.showMultiSelect = false;
        this.questionEditForm.get('paragraphText')?.addValidators(Validators.required);
        this.questionEditForm.get('questionImage')?.clearValidators();
        this.questionEditForm.get('questionImage')?.setErrors(null);
        break;
      default:
        console.log(`non-existent size: ${this.enum.SingleSelection}`);
        break;
    }
  }

  onCancel() {
    this.router.navigate(['/question']);
  }

  getQuestionSetList() {
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.test.GetQuestionSetListWithOutCount;
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        if (data && data.data && data.data.length > 0) {
          for (let i = 0; i < data.data.length; i++) {
            this.questionSetList.push({ 'id': data.data[i].questionSetId, 'value': data.data[i].questionSetName })
          }
          this.spinner.hide();
        }
      },
      error: (err) => {
        console.log('getHandlerList-Error', err);
      }
    });
  }

  getQuestionTypeList() {
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.question.GetQuestionTypes;
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        if (data && data.data && data.data.length > 0) {
          for (let i = 0; i < data.data.length; i++) {
            this.questionTypeList.push({ 'id': data.data[i].questionTypeId, 'value': data.data[i].questionTypeText })
          }
          this.spinner.hide();
        }
      },
      error: (err) => {
        console.log('getHandlerList-Error', err);
      }
    });
  }

  get questionFormControl() {
    return this.questionEditForm.controls;
  }

  get contacts() {
    return this.questionEditForm.controls['questionOptions'] as FormArray;
  }

  getFormGroup(index: number): FormGroup {
    return this.contacts.at(index) as FormGroup;
  }

  get questionOptions(): FormArray {
    return this.questionEditForm.get('questionOptions') as FormArray;
  }

  multiOptionCheck(i, j) {
    this.multiOptionCheckItem = this.questionEditForm.get('multiQuestions') as FormArray;
    const multiOptions = this.multiOptionCheckItem.at(i) as FormGroup
    const options = multiOptions.get('multiOptions') as FormArray
    const formGroup = options.at(j) as FormGroup
    return formGroup;
  }

  CheckCorrect(i: number) {
    return this.getFormGroup(i).get('isCorrectAnswer')?.value;
  }

  CheckParagraphCorrect(i: number, j: number) {
    return this.multiOptionCheck(i, j).get('isCorrectAnswer')?.value;
  }
}
